export default {
  buttonLabel: 'Account Statement',
};
